import * as React from "react"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import CoastalHollywood from "../../components/ArtStyle/CoastalHollywood"

const CoastalHollywoodPage = () => (
  <Layout>
    <Seo title="Coastal Hollywood" />
    <CoastalHollywood />
  </Layout>
)

export default CoastalHollywoodPage
